"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./RefundTextComponent.scss");
const RoutesPaths_1 = require("../../routes/RoutesPaths");
const RefundTextComponent = ({ bookId }) => {
    const refundFormLink = `https://form.refundable.me/forms/refund?memberId=349&bookingReference=${bookId || '(bookID)'}`;
    return (react_1.default.createElement("div", { className: "RefundTextComponent" },
        react_1.default.createElement("p", null,
            "Atrav\u00E9s do site da\u00A0",
            react_1.default.createElement("a", { href: RoutesPaths_1.routesPaths.root }, "360suites.com.br"),
            ", o usu\u00E1rio dever\u00E1 selecionar antes da conclus\u00E3o do pagamento por uma das op\u00E7\u00F5es abaixo:"),
        react_1.default.createElement("div", { className: "refund-items-container" },
            react_1.default.createElement("span", null,
                "a) ",
                react_1.default.createElement("u", null, "\"Reserva Reembols\u00E1vel\"")),
            react_1.default.createElement("span", null,
                "b) ",
                react_1.default.createElement("u", null, "\"Reserva N\u00E3o Reembols\u00E1vel\""))),
        react_1.default.createElement("div", { className: "refund-title" },
            "a) ",
            react_1.default.createElement("u", null, "Reserva Reembols\u00E1vel")),
        react_1.default.createElement("p", null,
            "Caso o usu\u00E1rio selecione a op\u00E7\u00E3o ",
            react_1.default.createElement("b", null, "\"Reserva Reembols\u00E1vel\""),
            ", o mesmo ter\u00E1 a op\u00E7\u00E3o de",
            react_1.default.createElement("b", null, " reembolso total "),
            "se n\u00E3o puder comparecer em fun\u00E7\u00E3o dos motivos listados em nossos\u00A0",
            react_1.default.createElement("a", { href: "https://www.refundable.me/extended/pt-Br/" }, "Termos & Condi\u00E7\u00F5es"),
            "."),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, "Importante: "),
            "A op\u00E7\u00E3o de \"Reserva Reembols\u00E1vel\" protege os nossos h\u00F3spedes dos imprevistos listados nos\u00A0",
            react_1.default.createElement("a", { href: "https://www.refundable.me/extended/pt-Br/" }, "Termos & Condi\u00E7\u00F5es"),
            "\u00A0at\u00E9 a",
            react_1.default.createElement("b", null, " data do check-in "),
            "ou at\u00E9 60 dias ap\u00F3s a data do check-in caso seja comprovado o",
            react_1.default.createElement("b", null, " n\u00E3o comparecimento (\"no show\")"),
            "."),
        react_1.default.createElement("p", null,
            "Caso a solicita\u00E7\u00E3o cumpra com os crit\u00E9rios listados acima, o usu\u00E1rio dever\u00E1 preencher o",
            react_1.default.createElement("b", null, " formul\u00E1rio de reembolso"),
            "\u00A0atrav\u00E9s\u00A0",
            react_1.default.createElement("a", { href: refundFormLink, target: "_blank" }, "deste link"),
            "."),
        react_1.default.createElement("p", null,
            "Ap\u00F3s preenchimento do formul\u00E1rio, entraremos em contato em at\u00E9",
            react_1.default.createElement("b", null, " 1 dia \u00FAtil "),
            "para conclus\u00E3o do processo de reembolso. Ap\u00F3s nosso contato, o reembolso ser\u00E1 realizado\u00A0",
            react_1.default.createElement("b", null, "em at\u00E9 72h"),
            "."),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, "Aten\u00E7\u00E3o: "),
            "Se a solicita\u00E7\u00E3o de reembolso for realizada",
            react_1.default.createElement("b", null, " ap\u00F3s a confirma\u00E7\u00E3o do check-in ou durante a estadia"),
            ", o caso ser\u00E1 analisado individualmente",
            react_1.default.createElement("b", null, " sem qualquer garantia "),
            "do reembolso total ou parcial da reserva."),
        react_1.default.createElement("div", { className: "refund-title" },
            "b) ",
            react_1.default.createElement("u", null, "Reserva N\u00E3o Reembols\u00E1vel")),
        react_1.default.createElement("p", null,
            "Caso o usu\u00E1rio selecione a op\u00E7\u00E3o",
            react_1.default.createElement("b", null, " \"Reserva N\u00E3o Reembols\u00E1vel\""),
            ", o cancelamento da reserva poder\u00E1 ser realizado gratuitamente at\u00E9",
            react_1.default.createElement("b", null, " 72 horas antes da data e hor\u00E1rio "),
            "de entrada no apartamento. Ou seja, at\u00E9 72 horas antes da data do check-in, \u00E0s 15h."),
        react_1.default.createElement("p", null,
            "Para realizar a solicita\u00E7\u00E3o de reembolso, basta entrar em contato com o nosso",
            react_1.default.createElement("b", null, " time de atendimento "),
            "atrav\u00E9s dos nossos canais de comunica\u00E7\u00E3o. Neste cen\u00E1rio, damos o prazo de",
            react_1.default.createElement("b", null, " 3 dias \u00FAteis "),
            "para realiza\u00E7\u00E3o do reembolso, al\u00E9m do prazo da operadora de cart\u00E3o de cr\u00E9dito, se aplic\u00E1vel."),
        react_1.default.createElement("p", null,
            react_1.default.createElement("div", null,
                react_1.default.createElement("b", null, "E-mail: "),
                "contato@360suites.com.br"),
            react_1.default.createElement("div", null,
                react_1.default.createElement("b", null, "WhatsApp: "),
                "+55 (11) 96171-8008"),
            react_1.default.createElement("div", null,
                react_1.default.createElement("b", null, "Liga\u00E7\u00F5es: "),
                "+55 (11) 3136-1757")),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, "Aten\u00E7\u00E3o: "),
            "Em casos de cancelamentos",
            react_1.default.createElement("b", null, " fora do prazo de 72h ou durante a estadia"),
            ", a reserva se aplica como",
            react_1.default.createElement("b", null,
                " ",
                react_1.default.createElement("u", null, "N\u00E3o Reembols\u00E1vel"),
                " "),
            "e o valor da mesma ser\u00E1 cobrado integralmente."),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, "Observa\u00E7\u00E3o Importante: "),
            "As pol\u00EDticas e regras listadas em nossa p\u00E1gina\u00A0",
            react_1.default.createElement("a", { href: "https://www.360suites.com.br/politicas-cancelamento" }, " 360suites.com.br/politicas-cancelamento"),
            "\u00A0",
            react_1.default.createElement("b", null, "s\u00E3o inegoci\u00E1veis"),
            ".")));
};
exports.default = RefundTextComponent;
